import { Button } from "../../forms/Button";

export type ModalFooterProps = {
	actions?: React.ReactNode;
	onClose?: () => void;
	variant?: "default" | "fullScreen";
	i18n: { cancelButton: string };
};

export const ModalFooter = ({ actions, onClose, variant = "default", i18n }: ModalFooterProps) => {
	return (
		<>
			{actions ? (
				<div className="mt-5 flex flex-col gap-2 sm:mt-4 sm:flex-row-reverse">{actions}</div>
			) : onClose && variant === "default" ? (
				<div className="mt-5 flex w-full flex-col sm:mt-4 sm:hidden">
					<Button type="button" intent="secondary" onClick={onClose}>
						{i18n.cancelButton}
					</Button>
				</div>
			) : null}
		</>
	);
};
